import React from "react";
import DropDownButton from "devextreme-react/drop-down-button";

const dropDownOptions = { width: 280, height: 120 };

/**
 * Options menu for a grid's own toolbar — the web counterpart of a legacy grid navigator's Options
 * popup menu. Each grid supplies its own operations as `{ id, name }` items, declared in
 * `enum/Enum.js` next to the legacy menu they come from.
 *
 * The Sales Order Management top grid's header-level menu is a different thing — see
 * SalesOrderOptionsButton.
 */
const GridOptionsButton = ({ items, onItemClick, disabled = false }) => (
    <DropDownButton
        icon="fa fa-cogs"
        text="Options"
        stylingMode="text"
        dropDownOptions={dropDownOptions}
        items={items}
        onItemClick={onItemClick}
        displayExpr="name"
        keyExpr="id"
        disabled={disabled}
    />
);

export default GridOptionsButton;
